import gql from 'graphql-tag';

const GET_ALL = gql`
    query all($perPage: Int!, $page: Int, $where: KodeSuratWhereWhereConditions){
        kodeSurat(first: $perPage, page: $page, where: $where){
            data{
                id,
                uuid,
                kode_surat,
                nama,
                sub_dari,
                bisa_dipilih,
                urutan
            }
        }
    }
`;

export {
    GET_ALL
}
